const countriesCode = [
  {
    name: 'United States',
    flag: '🇺🇸',
    code: 'US',
    dialCode: '+1',
    displayName: '🇺🇸 +1 United States (US)',
  },
  {
    name: 'Afghanistan',
    flag: '🇦🇫',
    code: 'AF',
    dialCode: '+93',
    displayName: '🇦🇫 +93 Afghanistan (AF)',
  },
  {
    name: 'Åland Islands',
    flag: '🇦🇽',
    code: 'AX',
    dialCode: '+358',
    displayName: '🇦🇽 +358 Åland Islands (AX)',
  },
  {
    name: 'Albania',
    flag: '🇦🇱',
    code: 'AL',
    dialCode: '+355',
    displayName: '🇦🇱 +355 Albania (AL)',
  },
  {
    name: 'Algeria',
    flag: '🇩🇿',
    code: 'DZ',
    dialCode: '+213',
    displayName: '🇩🇿 +213 Algeria (DZ)',
  },
  {
    name: 'American Samoa',
    flag: '🇦🇸',
    code: 'AS',
    dialCode: '+1684',
    displayName: '🇦🇸 +1684 American Samoa (AS)',
  },
  {
    name: 'Andorra',
    flag: '🇦🇩',
    code: 'AD',
    dialCode: '+376',
    displayName: '🇦🇩 +376 Andorra (AD)',
  },
  {
    name: 'Angola',
    flag: '🇦🇴',
    code: 'AO',
    dialCode: '+244',
    displayName: '🇦🇴 +244 Angola (AO)',
  },
  {
    name: 'Anguilla',
    flag: '🇦🇮',
    code: 'AI',
    dialCode: '+1264',
    displayName: '🇦🇮 +1264 Anguilla (AI)',
  },
  {
    name: 'Antarctica',
    flag: '🇦🇶',
    code: 'AQ',
    dialCode: '+672',
    displayName: '🇦🇶 +672 Antarctica (AQ)',
  },
  {
    name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    code: 'AG',
    dialCode: '+1268',
    displayName: '🇦🇬 +1268 Antigua and Barbuda (AG)',
  },
  {
    name: 'Argentina',
    flag: '🇦🇷',
    code: 'AR',
    dialCode: '+54',
    displayName: '🇦🇷 +54 Argentina (AR)',
  },
  {
    name: 'Armenia',
    flag: '🇦🇲',
    code: 'AM',
    dialCode: '+374',
    displayName: '🇦🇲 +374 Armenia (AM)',
  },
  {
    name: 'Aruba',
    flag: 'aw',
    code: 'AW',
    dialCode: '+297',
    displayName: '🇦🇼 +297 Aruba (AW)',
  },
  {
    name: 'Australia',
    flag: '🇦🇺',
    code: 'AU',
    dialCode: '+61',
    displayName: '🇦🇺 +61 Australia (AU)',
  },
  {
    name: 'Austria',
    flag: '🇦🇹',
    code: 'AT',
    dialCode: '+43',
    displayName: '🇦🇹 +43 Austria (AT)',
  },
  {
    name: 'Azerbaijan',
    flag: '🇦🇿',
    code: 'AZ',
    dialCode: '+994',
    displayName: '🇦🇿 +994 Azerbaijan (AZ)',
  },
  {
    name: 'Bahamas',
    flag: '🇧🇸',
    code: 'BS',
    dialCode: '+1242',
    displayName: '🇧🇸 +1242 Bahamas (BS)',
  },
  {
    name: 'Bahrain',
    flag: '🇧🇭',
    code: 'BH',
    dialCode: '+973',
    displayName: '🇧🇭 +973 Bahrain (BH)',
  },
  {
    name: 'Bangladesh',
    flag: '🇧🇩',
    code: 'BD',
    dialCode: '+880',
    displayName: '🇧🇩 +880 Bangladesh (BD)',
  },
  {
    name: 'Barbados',
    flag: '🇧🇧',
    code: 'BB',
    dialCode: '+1246',
    displayName: '🇧🇧 +1246 Barbados (BB)',
  },
  {
    name: 'Belarus',
    flag: '🇧🇾',
    code: 'BY',
    dialCode: '+375',
    displayName: '🇧🇾 +375 Belarus (BY)',
  },
  {
    name: 'Belgium',
    flag: '🇧🇪',
    code: 'BE',
    dialCode: '+32',
    displayName: '🇧🇪 +32 Belgium (BE)',
  },
  {
    name: 'Belize',
    flag: '🇧🇿',
    code: 'BZ',
    dialCode: '+501',
    displayName: '🇧🇿 +501 Belize (BZ)',
  },
  {
    name: 'Benin',
    flag: '🇧🇯',
    code: 'BJ',
    dialCode: '+229',
    displayName: '🇧🇯 +229 Benin (BJ)',
  },
  {
    name: 'Bermuda',
    flag: '🇧🇲',
    code: 'BM',
    dialCode: '+1441',
    displayName: '🇧🇲 +1441 Bermuda (BM)',
  },
  {
    name: 'Bhutan',
    flag: '🇧🇹',
    code: 'BT',
    dialCode: '+975',
    displayName: '🇧🇹 +975 Bhutan (BT)',
  },
  {
    name: 'Bolivia, Plurinational State of bolivia',
    flag: '🇧🇴',
    code: 'BO',
    dialCode: '+591',
    displayName: '🇧🇴 +591 Bolivia, Plurinational State of bolivia (BO)',
  },
  {
    name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    code: 'BA',
    dialCode: '+387',
    displayName: '🇧🇦 +387 Bosnia and Herzegovina (BA)',
  },
  {
    name: 'Botswana',
    flag: '🇧🇼',
    code: 'BW',
    dialCode: '+267',
    displayName: '🇧🇼 +267 Botswana (BW)',
  },
  {
    name: 'Bouvet Island',
    flag: '🇧🇻',
    code: 'BV',
    dialCode: '+47',
    displayName: '🇧🇻 +47 Botswana (BW)',
  },
  {
    name: 'Brazil',
    flag: '🇧🇷',
    code: 'BR',
    dialCode: '+55',
    displayName: '🇧🇷 +55 Bouvet Island (BW)',
  },
  {
    name: 'British Indian Ocean Territory',
    flag: '🇮🇴',
    code: 'IO',
    dialCode: '+246',
    displayName: '🇮🇴 +246 British Indian Ocean Territory (IO)',
  },
  {
    name: 'Brunei Darussalam',
    flag: '🇧🇳',
    code: 'BN',
    dialCode: '+673',
    displayName: '🇧🇳 +673 Brunei Darussalam (BN)',
  },
  {
    name: 'Bulgaria',
    flag: '🇧🇬',
    code: 'BG',
    dialCode: '+359',
    displayName: '🇧🇬 +359 Bulgaria (BG)',
  },
  {
    name: 'Burkina Faso',
    flag: '🇧🇫',
    code: 'BF',
    dialCode: '+226',
    displayName: '🇧🇫 +226 Burkina Faso (BF)',
  },
  {
    name: 'Burundi',
    flag: '🇧🇮',
    code: 'BI',
    dialCode: '+257',
    displayName: '🇧🇮 +257 Burundi (BI)',
  },
  {
    name: 'Cambodia',
    flag: '🇰🇭',
    code: 'KH',
    dialCode: '+855',
    displayName: '🇰🇭 +855 Cambodia (KH)',
  },
  {
    name: 'Cameroon',
    flag: '🇨🇲',
    code: 'CM',
    dialCode: '+237',
    displayName: '🇨🇲 +237 Cameroon (CM)',
  },
  {
    name: 'Canada',
    flag: '🇨🇦',
    code: 'CA',
    dialCode: '+1',
    displayName: '🇨🇦 +1 Canada (CA)',
  },
  {
    name: 'Cape Verde',
    flag: '🇨🇻',
    code: 'CV',
    dialCode: '+238',
    displayName: '🇨🇻 +238 Cape Verde (CV)',
  },
  {
    name: 'Cayman Islands',
    flag: '🇰🇾',
    code: 'KY',
    dialCode: '+1345',
    displayName: '🇰🇾 +1345 Cayman Islands (KY)',
  },
  {
    name: 'Central African Republic',
    flag: '🇨🇫',
    code: 'CF',
    dialCode: '+236',
    displayName: '🇨🇫 +236 Central African Republic (CF)',
  },
  {
    name: 'Chad',
    flag: '🇹🇩',
    code: 'TD',
    dialCode: '+235',
    displayName: '🇹🇩 +235 Chad (TD)',
  },
  {
    name: 'Chile',
    flag: '🇨🇱',
    code: 'CL',
    dialCode: '+56',
    displayName: '🇨🇱 +56 Chile (CL)',
  },
  {
    name: 'China',
    flag: '🇨🇳',
    code: 'CN',
    dialCode: '+86',
    displayName: '🇨🇳 +86 China (CN)',
  },
  {
    name: 'Christmas Island',
    flag: '🇨🇽',
    code: 'CX',
    dialCode: '+61',
    displayName: '🇨🇽 +61 Christmas Island (CX)',
  },
  {
    name: 'Cocos (Keeling) Islands',
    flag: '🇨🇨',
    code: 'CC',
    dialCode: '+61',
    displayName: '🇨🇨 +61 Cocos (Keeling) Islands (CC)',
  },
  {
    name: 'Colombia',
    flag: '🇨🇴',
    code: 'CO',
    dialCode: '+57',
    displayName: '🇨🇴 +57 Colombia (CO)',
  },
  {
    name: 'Comoros',
    flag: '🇰🇲',
    code: 'KM',
    dialCode: '+269',
    displayName: '🇰🇲 +269 Comoros (KM)',
  },
  {
    name: 'Congo',
    flag: '🇨🇬',
    code: 'CG',
    dialCode: '+242',
    displayName: '🇨🇬 +242 Congo (CG)',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    flag: '🇨🇩',
    code: 'CD',
    dialCode: '+243',
    displayName: '🇨🇩 +243 Congo, The Democratic Republic of the Congo (CD)',
  },
  {
    name: 'Cook Islands',
    flag: '🇨🇰',
    code: 'CK',
    dialCode: '+682',
    displayName: '🇨🇰 +682 Cook Islands (CK)',
  },
  {
    name: 'Costa Rica',
    flag: '🇨🇷',
    code: 'CR',
    dialCode: '+506',
    displayName: '🇨🇷 +506 Costa Rica (CR)',
  },
  {
    name: "Cote d'Ivoire",
    flag: '🇨🇮',
    code: 'CI',
    dialCode: '+225',
    displayName: "🇨🇮 +225 Cote d'Ivoire (CI)",
  },
  {
    name: 'Croatia',
    flag: '🇭🇷',
    code: 'HR',
    dialCode: '+385',
    displayName: '🇭🇷 +385 Croatia (HR)',
  },
  {
    name: 'Cuba',
    flag: '🇨🇺',
    code: 'CU',
    dialCode: '+53',
    displayName: '🇨🇺 +53 Cuba (CU)',
  },
  {
    name: 'Cyprus',
    flag: '🇨🇾',
    code: 'CY',
    dialCode: '+357',
    displayName: '🇨🇾 +357 Cyprus (CY)',
  },
  {
    name: 'Czech Republic',
    flag: '🇨🇿',
    code: 'CZ',
    dialCode: '+420',
    displayName: '🇨🇿 +420 Czech Republic (CZ)',
  },
  {
    name: 'Denmark',
    flag: '🇩🇰',
    code: 'DK',
    dialCode: '+45',
    displayName: '🇩🇰 +45 Denmark (DK)',
  },
  {
    name: 'Djibouti',
    flag: '🇩🇯',
    code: 'DJ',
    dialCode: '+253',
    displayName: '🇩🇯 +253 Djibouti (DJ)',
  },
  {
    name: 'Dominica',
    flag: '🇩🇲',
    code: 'DM',
    dialCode: '+1767',
    displayName: '🇩🇲 +1767 Dominica (DM)',
  },
  {
    name: 'Dominican Republic',
    flag: '🇩🇴',
    code: 'DO',
    dialCode: '+1849',
    displayName: '🇩🇴 +1849 Dominican Republic (DO)',
  },
  {
    name: 'Ecuador',
    flag: '🇪🇨',
    code: 'EC',
    dialCode: '+593',
    displayName: '🇪🇨 +593 Ecuador (EC)',
  },
  {
    name: 'Egypt',
    flag: '🇪🇬',
    code: 'EG',
    dialCode: '+20',
    displayName: '🇪🇬 +20 Egypt (EG)',
  },
  {
    name: 'El Salvador',
    flag: '🇸🇻',
    code: 'SV',
    dialCode: '+503',
    displayName: '🇸🇻 +503 El Salvador (SV)',
  },
  {
    name: 'Equatorial Guinea',
    flag: '🇬🇶',
    code: 'GQ',
    dialCode: '+240',
    displayName: '🇬🇶 +240 Equatorial Guinea (GQ)',
  },
  {
    name: 'Eritrea',
    flag: '🇪🇷',
    code: 'ER',
    dialCode: '+291',
    displayName: '🇪🇷 +291 Eritrea (ER)',
  },
  {
    name: 'Estonia',
    flag: '🇪🇪',
    code: 'EE',
    dialCode: '+372',
    displayName: '🇪🇪 +372 Estonia (EE)',
  },
  {
    name: 'Ethiopia',
    flag: '🇪🇹',
    code: 'ET',
    dialCode: '+251',
    displayName: '🇪🇹 +251 Ethiopia (ET)',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    flag: '🇫🇰',
    code: 'FK',
    dialCode: '+500',
    displayName: '🇫🇰 +500 Falkland Islands (Malvinas) (FK)',
  },
  {
    name: 'Faroe Islands',
    flag: '🇫🇴',
    code: 'FO',
    dialCode: '+298',
    displayName: '🇫🇴 +298 Faroe Islands (FO)',
  },
  {
    name: 'Fiji',
    flag: '🇫🇯',
    code: 'FJ',
    dialCode: '+679',
    displayName: '🇫🇯 +679 Fiji (FJ)',
  },
  {
    name: 'Finland',
    flag: '🇫🇮',
    code: 'FI',
    dialCode: '+358',
    displayName: '🇫🇮 +358 Finland (FI)',
  },
  {
    name: 'France',
    flag: '🇫🇷',
    code: 'FR',
    dialCode: '+33',
    displayName: '🇫🇷 +33 France (FR)',
  },
  {
    name: 'French Guiana',
    flag: '🇬🇫',
    code: 'GF',
    dialCode: '+594',
    displayName: '🇬🇫 +594 French Guiana (GF)',
  },
  {
    name: 'French Polynesia',
    flag: '🇵🇫',
    code: 'PF',
    dialCode: '+689',
    displayName: '🇵🇫 +689 French Polynesia (PF)',
  },
  {
    name: 'French Southern Territories',
    flag: '🇹🇫',
    code: 'TF',
    dialCode: '+262',
    displayName: '🇹🇫 +262 French Southern Territories (TF)',
  },
  {
    name: 'Gabon',
    flag: '🇬🇦',
    code: 'GA',
    dialCode: '+241',
    displayName: '🇬🇦 +241 Gabon (GA)',
  },
  {
    name: 'Gambia',
    flag: '🇬🇲',
    code: 'GM',
    dialCode: '+220',
    displayName: '🇬🇲 +220 Gambia (GM)',
  },
  {
    name: 'Georgia',
    flag: '🇬🇪',
    code: 'GE',
    dialCode: '+995',
    displayName: '🇬🇪 +995 Georgia (GE)',
  },
  {
    name: 'Germany',
    flag: '🇩🇪',
    code: 'DE',
    dialCode: '+49',
    displayName: '🇩🇪 +49 Germany (DE)',
  },
  {
    name: 'Ghana',
    flag: '🇬🇭',
    code: 'GH',
    dialCode: '+233',
    displayName: '🇬🇭 +233 Ghana (GH)',
  },
  {
    name: 'Gibraltar',
    flag: '🇬🇮',
    code: 'GI',
    dialCode: '+350',
    displayName: '🇬🇮 +350 Gibraltar (GI)',
  },
  {
    name: 'Greece',
    flag: '🇬🇷',
    code: 'GR',
    dialCode: '+30',
    displayName: '🇬🇷 +30 Greece (GR)',
  },
  {
    name: 'Greenland',
    flag: '🇬🇱',
    code: 'GL',
    dialCode: '+299',
    displayName: '🇬🇱 +299 Greenland (GL)',
  },
  {
    name: 'Grenada',
    flag: '🇬🇩',
    code: 'GD',
    dialCode: '+1473',
    displayName: '🇬🇩 +1473 Grenada (GD)',
  },
  {
    name: 'Guadeloupe',
    flag: '🇬🇵',
    code: 'GP',
    dialCode: '+590',
    displayName: '🇬🇵 +590 Guadeloupe (GP)',
  },
  {
    name: 'Guam',
    flag: '🇬🇺',
    code: 'GU',
    dialCode: '+1671',
    displayName: '🇬🇺 +1671 Guam (GU)',
  },
  {
    name: 'Guatemala',
    flag: '🇬🇹',
    code: 'GT',
    dialCode: '+502',
    displayName: '🇬🇹 +502 Guatemala (GT)',
  },
  {
    name: 'Guernsey',
    flag: '🇬🇬',
    code: 'GG',
    dialCode: '+44',
    displayName: '🇬🇬 +44 Guernsey (GG)',
  },
  {
    name: 'Guinea',
    flag: '🇬🇳',
    code: 'GN',
    dialCode: '+224',
    displayName: '🇬🇳 +224 Guinea (GN)',
  },
  {
    name: 'Guinea-Bissau',
    flag: '🇬🇼',
    code: 'GW',
    dialCode: '+245',
    displayName: '🇬🇼 +245 Guinea-Bissau (GW)',
  },
  {
    name: 'Guyana',
    flag: '🇬🇾',
    code: 'GY',
    dialCode: '+592',
    displayName: '🇬🇾 +592 Guyana (GY)',
  },
  {
    name: 'Haiti',
    flag: '🇭🇹',
    code: 'HT',
    dialCode: '+509',
    displayName: '🇭🇹 +509 Haiti (HT)',
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    flag: '🇭🇲',
    code: 'HM',
    dialCode: '+672',
    displayName: '🇭🇲 +672 Heard Island and Mcdonald Islands (HM)',
  },
  {
    name: 'Holy See (Vatican City State)',
    flag: '🇻🇦',
    code: 'VA',
    dialCode: '+379',
    displayName: '🇻🇦 +379 Holy See (Vatican City State) (VA)',
  },
  {
    name: 'Honduras',
    flag: '🇭🇳',
    code: 'HN',
    dialCode: '+504',
    displayName: '🇭🇳 +504 Honduras (HN)',
  },
  {
    name: 'Hong Kong',
    flag: '🇭🇰',
    code: 'HK',
    dialCode: '+852',
    displayName: '🇭🇰 +852 Hong Kong (HK)',
  },
  {
    name: 'Hungary',
    flag: '🇭🇺',
    code: 'HU',
    dialCode: '+36',
    displayName: '🇭🇺 +36 Hungary (HU)',
  },
  {
    name: 'Iceland',
    flag: '🇮🇸',
    code: 'IS',
    dialCode: '+354',
    displayName: '🇮🇸 +354 Iceland (IS)',
  },
  {
    name: 'India',
    flag: '🇮🇳',
    code: 'IN',
    dialCode: '+91',
    displayName: '🇮🇳 +91 India (IN)',
  },
  {
    name: 'Indonesia',
    flag: '🇮🇩',
    code: 'ID',
    dialCode: '+62',
    displayName: '🇮🇩 +62 Indonesia (ID)',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    flag: '🇮🇷',
    code: 'IR',
    dialCode: '+98',
    displayName: '🇮🇷 +98 Iran, Islamic Republic of Persian Gulf (IR)',
  },
  {
    name: 'Iraq',
    flag: '🇮🇶',
    code: 'IQ',
    dialCode: '+964',
    displayName: '🇮🇶 +964 Iraq (IQ)',
  },
  {
    name: 'Ireland',
    flag: '🇮🇪',
    code: 'IE',
    dialCode: '+353',
    displayName: '🇮🇪 +353 Ireland (IE)',
  },
  {
    name: 'Isle of Man',
    flag: '🇮🇲',
    code: 'IM',
    dialCode: '+44',
    displayName: '🇮🇲 +44 Isle of Man (IM)',
  },
  {
    name: 'Israel',
    flag: '🇮🇱',
    code: 'IL',
    dialCode: '+972',
    displayName: '🇮🇱 +972 Israel (IL)',
  },
  {
    name: 'Italy',
    flag: '🇮🇹',
    code: 'IT',
    dialCode: '+39',
    displayName: '🇮🇹 +39 Italy (IT)',
  },
  {
    name: 'Jamaica',
    flag: '🇯🇲',
    code: 'JM',
    dialCode: '+1876',
    displayName: '🇯🇲 +1876 Jamaica (JM)',
  },
  {
    name: 'Japan',
    flag: '🇯🇵',
    code: 'JP',
    dialCode: '+81',
    displayName: '🇯🇵 +81 Japan (JP)',
  },
  {
    name: 'Jersey',
    flag: '🇯🇪',
    code: 'JE',
    dialCode: '+44',
    displayName: '🇯🇪 +44 Jersey (JE)',
  },
  {
    name: 'Jordan',
    flag: '🇯🇴',
    code: 'JO',
    dialCode: '+962',
    displayName: '🇯🇴 +962 Jordan (JO)',
  },
  {
    name: 'Kazakhstan',
    flag: '🇰🇿',
    code: 'KZ',
    dialCode: '+7',
    displayName: '🇰🇿 +7 Kazakhstan (KZ)',
  },
  {
    name: 'Kenya',
    flag: '🇰🇪',
    code: 'KE',
    dialCode: '+254',
    displayName: '🇰🇪 +254 Kenya (KE)',
  },
  {
    name: 'Kiribati',
    flag: '🇰🇮',
    code: 'KI',
    dialCode: '+686',
    displayName: '🇰🇮 +686 Kiribati (KI)',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    flag: '🇰🇵',
    code: 'KP',
    dialCode: '+850',
    displayName: "🇰🇵 +850 Korea, Democratic People's Republic of Korea (KP)",
  },
  {
    name: 'Korea, Republic of South Korea',
    flag: '🇰🇷',
    code: 'KR',
    dialCode: '+82',
    displayName: '🇰🇷 +82 Korea, Republic of South Korea (KR)',
  },
  {
    name: 'Kosovo',
    flag: '🇽🇰',
    code: 'XK',
    dialCode: '+383',
    displayName: '🇽🇰 +383 Kosovo (XK)',
  },
  {
    name: 'Kuwait',
    flag: '🇰🇼',
    code: 'KW',
    dialCode: '+965',
    displayName: '🇰🇼 +965 Kuwait (KW)',
  },
  {
    name: 'Kyrgyzstan',
    flag: '🇰🇬',
    code: 'KG',
    dialCode: '+996',
    displayName: '🇰🇬 +996 Kyrgyzstan (KG)',
  },
  {
    name: 'Laos',
    flag: '🇱🇦',
    code: 'LA',
    dialCode: '+856',
    displayName: '🇱🇦 +856 Laos (LA)',
  },
  {
    name: 'Latvia',
    flag: '🇱🇻',
    code: 'LV',
    dialCode: '+371',
    displayName: '🇱🇻 +371 Latvia (LV)',
  },
  {
    name: 'Lebanon',
    flag: '🇱🇧',
    code: 'LB',
    dialCode: '+961',
    displayName: '🇱🇧 +961 Lebanon (LB)',
  },
  {
    name: 'Lesotho',
    flag: '🇱🇸',
    code: 'LS',
    dialCode: '+266',
    displayName: '🇱🇸 +266 Lesotho (LS)',
  },
  {
    name: 'Liberia',
    flag: '🇱🇷',
    code: 'LR',
    dialCode: '+231',
    displayName: '🇱🇷 +231 Liberia (LR)',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    flag: '🇱🇾',
    code: 'LY',
    dialCode: '+218',
    displayName: '🇱🇾 +218 Libyan Arab Jamahiriya (LY)',
  },
  {
    name: 'Liechtenstein',
    flag: '🇱🇮',
    code: 'LI',
    dialCode: '+423',
    displayName: '🇱🇮 +423 Liechtenstein (LI)',
  },
  {
    name: 'Lithuania',
    flag: '🇱🇹',
    code: 'LT',
    dialCode: '+370',
    displayName: '🇱🇹 +370 Lithuania (LT)',
  },
  {
    name: 'Luxembourg',
    flag: '🇱🇺',
    code: 'LU',
    dialCode: '+352',
    displayName: '🇱🇺 +352 Luxembourg (LU)',
  },
  {
    name: 'Macao',
    flag: '🇲🇴',
    code: 'MO',
    dialCode: '+853',
    displayName: '🇲🇴 +853 Macao (MO)',
  },
  {
    name: 'Macedonia',
    flag: '🇲🇰',
    code: 'MK',
    dialCode: '+389',
    displayName: '🇲🇰 +389 Macedonia (MK)',
  },
  {
    name: 'Madagascar',
    flag: '🇲🇬',
    code: 'MG',
    dialCode: '+261',
    displayName: '🇲🇬 +261 Madagascar (MG)',
  },
  {
    name: 'Malawi',
    flag: '🇲🇼',
    code: 'MW',
    dialCode: '+265',
    displayName: '🇲🇼 +265 Malawi (MW)',
  },
  {
    name: 'Malaysia',
    flag: '🇲🇾',
    code: 'MY',
    dialCode: '+60',
    displayName: '🇲🇾 +60 Malaysia (MY)',
  },
  {
    name: 'Maldives',
    flag: '🇲🇻',
    code: 'MV',
    dialCode: '+960',
    displayName: '🇲🇻 +960 Maldives (MV)',
  },
  {
    name: 'Mali',
    flag: '🇲🇱',
    code: 'ML',
    dialCode: '+223',
    displayName: '🇲🇱 +223 Mali (ML)',
  },
  {
    name: 'Malta',
    flag: '🇲🇹',
    code: 'MT',
    dialCode: '+356',
    displayName: '🇲🇹 +356 Malta (MT)',
  },
  {
    name: 'Marshall Islands',
    flag: '🇲🇭',
    code: 'MH',
    dialCode: '+692',
    displayName: '🇲🇭 +692 Marshall Islands (MH)',
  },
  {
    name: 'Martinique',
    flag: '🇲🇶',
    code: 'MQ',
    dialCode: '+596',
    displayName: '🇲🇶 +596 Martinique (MQ)',
  },
  {
    name: 'Mauritania',
    flag: '🇲🇷',
    code: 'MR',
    dialCode: '+222',
    displayName: '🇲🇷 +222 Mauritania (MR)',
  },
  {
    name: 'Mauritius',
    flag: '🇲🇺',
    code: 'MU',
    dialCode: '+230',
    displayName: '🇲🇺 +230 Mauritius (MU)',
  },
  {
    name: 'Mayotte',
    flag: '🇾🇹',
    code: 'YT',
    dialCode: '+262',
    displayName: '🇾🇹 +262 Mayotte (YT)',
  },
  {
    name: 'Mexico',
    flag: '🇲🇽',
    code: 'MX',
    dialCode: '+52',
    displayName: '🇲🇽 +52 Mexico (MX)',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    flag: '🇫🇲',
    code: 'FM',
    dialCode: '+691',
    displayName: '🇫🇲 +691 Micronesia, Federated States of Micronesia (FM)',
  },
  {
    name: 'Moldova',
    flag: '🇲🇩',
    code: 'MD',
    dialCode: '+373',
    displayName: '🇲🇩 +373 Moldova (MD)',
  },
  {
    name: 'Monaco',
    flag: '🇲🇨',
    code: 'MC',
    dialCode: '+377',
    displayName: '🇲🇨 +377 Monaco (MC)',
  },
  {
    name: 'Mongolia',
    flag: '🇲🇳',
    code: 'MN',
    dialCode: '+976',
    displayName: '🇲🇳 +976 Mongolia (MN)',
  },
  {
    name: 'Montenegro',
    flag: '🇲🇪',
    code: 'ME',
    dialCode: '+382',
    displayName: '🇲🇪 +382 Montenegro (ME)',
  },
  {
    name: 'Montserrat',
    flag: '🇲🇸',
    code: 'MS',
    dialCode: '+1664',
    displayName: '🇲🇸 +1664 Montserrat (MS)',
  },
  {
    name: 'Morocco',
    flag: '🇲🇦',
    code: 'MA',
    dialCode: '+212',
    displayName: '🇲🇦 +212 Morocco (MA)',
  },
  {
    name: 'Mozambique',
    flag: '🇲🇿',
    code: 'MZ',
    dialCode: '+258',
    displayName: '🇲🇿 +258 Mozambique (MZ)',
  },
  {
    name: 'Myanmar',
    flag: '🇲🇲',
    code: 'MM',
    dialCode: '+95',
    displayName: '🇲🇲 +95 Myanmar (MM)',
  },
  {
    name: 'Namibia',
    flag: '🇳🇦',
    code: 'NA',
    dialCode: '+264',
    displayName: '🇳🇦 +264 Namibia (NA)',
  },
  {
    name: 'Nauru',
    flag: '🇳🇷',
    code: 'NR',
    dialCode: '+674',
    displayName: '🇳🇷 +674 Nauru (NR)',
  },
  {
    name: 'Nepal',
    flag: '🇳🇵',
    code: 'NP',
    dialCode: '+977',
    displayName: '🇳🇵 +977 Nepal (NP)',
  },
  {
    name: 'Netherlands',
    flag: '🇳🇱',
    code: 'NL',
    dialCode: '+31',
    displayName: '🇳🇱 +31 Netherlands (NL)',
  },
  {
    name: 'Netherlands Antilles',
    flag: '',
    code: 'AN',
    dialCode: '+599',
    displayName: '+599 Netherlands Antilles (AN)',
  },
  {
    name: 'New Caledonia',
    flag: '🇳🇨',
    code: 'NC',
    dialCode: '+687',
    displayName: '🇳🇨 +687 New Caledonia (NC)',
  },
  {
    name: 'New Zealand',
    flag: '🇳🇿',
    code: 'NZ',
    dialCode: '+64',
    displayName: '🇳🇿 +64 New Zealand (NZ)',
  },
  {
    name: 'Nicaragua',
    flag: '🇳🇮',
    code: 'NI',
    dialCode: '+505',
    displayName: '🇳🇮 +505 Nicaragua (NI)',
  },
  {
    name: 'Niger',
    flag: '🇳🇪',
    code: 'NE',
    dialCode: '+227',
    displayName: '🇳🇪 +227 Niger (NE)',
  },
  {
    name: 'Nigeria',
    flag: '🇳🇬',
    code: 'NG',
    dialCode: '+234',
    displayName: '🇳🇬 +234 Nigeria (NG)',
  },
  {
    name: 'Niue',
    flag: '🇳🇺',
    code: 'NU',
    dialCode: '+683',
    displayName: '🇳🇺 +683 Niue (NU)',
  },
  {
    name: 'Norfolk Island',
    flag: '🇳🇫',
    code: 'NF',
    dialCode: '+672',
    displayName: '🇳🇫 +672 Norfolk Island (NF)',
  },
  {
    name: 'Northern Mariana Islands',
    flag: '🇲🇵',
    code: 'MP',
    dialCode: '+1670',
    displayName: '🇲🇵 +1670 Northern Mariana Islands (MP)',
  },
  {
    name: 'Norway',
    flag: '🇳🇴',
    code: 'NO',
    dialCode: '+47',
    displayName: '🇳🇴 +47 Norway (NO)',
  },
  {
    name: 'Oman',
    flag: '🇴🇲',
    code: 'OM',
    dialCode: '+968',
    displayName: '🇴🇲 +968 Oman (OM)',
  },
  {
    name: 'Pakistan',
    flag: '🇵🇰',
    code: 'PK',
    dialCode: '+92',
    displayName: '🇵🇰 +92 Pakistan (PK)',
  },
  {
    name: 'Palau',
    flag: '🇵🇼',
    code: 'PW',
    dialCode: '+680',
    displayName: '🇵🇼 +680 Palau (PW)',
  },
  {
    name: 'Palestinian Territory, Occupied',
    flag: '🇵🇸',
    code: 'PS',
    dialCode: '+970',
    displayName: '🇵🇸 +970 Palestinian Territory, Occupied (PS)',
  },
  {
    name: 'Panama',
    flag: '🇵🇦',
    code: 'PA',
    dialCode: '+507',
    displayName: '🇵🇦 +507 Panama (PA)',
  },
  {
    name: 'Papua New Guinea',
    flag: '🇵🇬',
    code: 'PG',
    dialCode: '+675',
    displayName: '🇵🇬 +675 Papua New Guinea (PG)',
  },
  {
    name: 'Paraguay',
    flag: '🇵🇾',
    code: 'PY',
    dialCode: '+595',
    displayName: '🇵🇾 +595 Paraguay (PY)',
  },
  {
    name: 'Peru',
    flag: '🇵🇪',
    code: 'PE',
    dialCode: '+51',
    displayName: '🇵🇪 +51 Peru (PE)',
  },
  {
    name: 'Philippines',
    flag: '🇵🇭',
    code: 'PH',
    dialCode: '+63',
    displayName: '🇵🇭 +63 Philippines (PH)',
  },
  {
    name: 'Pitcairn',
    flag: '🇵🇳',
    code: 'PN',
    dialCode: '+872',
    displayName: '🇵🇳 +872 Pitcairn (PN)',
  },
  {
    name: 'Poland',
    flag: '🇵🇱',
    code: 'PL',
    dialCode: '+48',
    displayName: '🇵🇱 +48 Poland (PL)',
  },
  {
    name: 'Portugal',
    flag: '🇵🇹',
    code: 'PT',
    dialCode: '+351',
    displayName: '🇵🇹 +351 Portugal (PT)',
  },
  {
    name: 'Puerto Rico',
    flag: '🇵🇷',
    code: 'PR',
    dialCode: '+1939',
    displayName: '🇵🇷 +1939 Puerto Rico (PR)',
  },
  {
    name: 'Qatar',
    flag: '🇶🇦',
    code: 'QA',
    dialCode: '+974',
    displayName: '🇶🇦 +974 Qatar (QA)',
  },
  {
    name: 'Romania',
    flag: '🇷🇴',
    code: 'RO',
    dialCode: '+40',
    displayName: '🇷🇴 +40 Romania (RO)',
  },
  {
    name: 'Russia',
    flag: '🇷🇺',
    code: 'RU',
    dialCode: '+7',
    displayName: '🇷🇺 +7 Russia (RU)',
  },
  {
    name: 'Rwanda',
    flag: '🇷🇼',
    code: 'RW',
    dialCode: '+250',
    displayName: '🇷🇼 +250 Rwanda (RW)',
  },
  {
    name: 'Reunion',
    flag: '🇷🇪',
    code: 'RE',
    dialCode: '+262',
    displayName: '🇷🇪 +262 Reunion (RE)',
  },
  {
    name: 'Saint Barthelemy',
    flag: '🇧🇱',
    code: 'BL',
    dialCode: '+590',
    displayName: '🇧🇱 +590 Saint Barthelemy (BL)',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    flag: '🇸🇭',
    code: 'SH',
    dialCode: '+290',
    displayName: '🇸🇭 +290 Saint Helena, Ascension and Tristan Da Cunha (SH)',
  },
  {
    name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    code: 'KN',
    dialCode: '+1869',
    displayName: '🇰🇳 +1869 Saint Kitts and Nevis (KN)',
  },
  {
    name: 'Saint Lucia',
    flag: '🇱🇨',
    code: 'LC',
    dialCode: '+1758',
    displayName: '🇱🇨 +1758 Saint Lucia (LC)',
  },
  {
    name: 'Saint Martin',
    flag: '🇲🇫',
    code: 'MF',
    dialCode: '+590',
    displayName: '🇲🇫 +590 Saint Martin (MF)',
  },
  {
    name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    code: 'PM',
    dialCode: '+508',
    displayName: '🇵🇲 +508 Saint Pierre and Miquelon (PM)',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    code: 'VC',
    dialCode: '+1784',
    displayName: '🇻🇨 +1784 Saint Vincent and the Grenadines (VC)',
  },
  {
    name: 'Samoa',
    flag: '🇼🇸',
    code: 'WS',
    dialCode: '+685',
    displayName: '🇼🇸 +685 Samoa (WS)',
  },
  {
    name: 'San Marino',
    flag: '🇸🇲',
    code: 'SM',
    dialCode: '+378',
    displayName: '🇸🇲 +378 San Marino (SM)',
  },
  {
    name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    code: 'ST',
    dialCode: '+239',
    displayName: '🇸🇹 +239 Sao Tome and Principe (ST)',
  },
  {
    name: 'Saudi Arabia',
    flag: '🇸🇦',
    code: 'SA',
    dialCode: '+966',
    displayName: '🇸🇦 +966 Saudi Arabia (SA)',
  },
  {
    name: 'Senegal',
    flag: '🇸🇳',
    code: 'SN',
    dialCode: '+221',
    displayName: '🇸🇳 +221 Senegal (SN)',
  },
  {
    name: 'Serbia',
    flag: '🇷🇸',
    code: 'RS',
    dialCode: '+381',
    displayName: '🇷🇸 +381 Serbia (RS)',
  },
  {
    name: 'Seychelles',
    flag: '🇸🇨',
    code: 'SC',
    dialCode: '+248',
    displayName: '🇸🇨 +248 Seychelles (SC)',
  },
  {
    name: 'Sierra Leone',
    flag: '🇸🇱',
    code: 'SL',
    dialCode: '+232',
    displayName: '🇸🇱 +232 Sierra Leone (SL)',
  },
  {
    name: 'Singapore',
    flag: '🇸🇬',
    code: 'SG',
    dialCode: '+65',
    displayName: '🇸🇬 +65 Singapore (SG)',
  },
  {
    name: 'Slovakia',
    flag: '🇸🇰',
    code: 'SK',
    dialCode: '+421',
    displayName: '🇸🇰 +421 Slovakia (SK)',
  },
  {
    name: 'Slovenia',
    flag: '🇸🇮',
    code: 'SI',
    dialCode: '+386',
    displayName: '🇸🇮 +386 Slovenia (SI)',
  },
  {
    name: 'Solomon Islands',
    flag: '🇸🇧',
    code: 'SB',
    dialCode: '+677',
    displayName: '🇸🇧 +677 Solomon Islands (SB)',
  },
  {
    name: 'Somalia',
    flag: '🇸🇴',
    code: 'SO',
    dialCode: '+252',
    displayName: '🇸🇴 +252 Somalia (SO)',
  },
  {
    name: 'South Africa',
    flag: '🇿🇦',
    code: 'ZA',
    dialCode: '+27',
    displayName: '🇿🇦 +27 South Africa (ZA)',
  },
  {
    name: 'South Sudan',
    flag: '🇸🇸',
    code: 'SS',
    dialCode: '+211',
    displayName: '🇸🇸 +211 South Sudan (SS)',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    code: 'GS',
    dialCode: '+500',
    displayName: '🇬🇸 +500 South Georgia and the South Sandwich Islands (GS)',
  },
  {
    name: 'Spain',
    flag: '🇪🇸',
    code: 'ES',
    dialCode: '+34',
    displayName: '🇪🇸 +34 Spain (ES)',
  },
  {
    name: 'Sri Lanka',
    flag: '🇱🇰',
    code: 'LK',
    dialCode: '+94',
    displayName: '🇱🇰 +94 Sri Lanka (LK)',
  },
  {
    name: 'Sudan',
    flag: '🇸🇩',
    code: 'SD',
    dialCode: '+249',
    displayName: '🇸🇩 +249 Sudan (SD)',
  },
  {
    name: 'Suriname',
    flag: '🇸🇷',
    code: 'SR',
    dialCode: '+597',
    displayName: '🇸🇷 +597 Suriname (SR)',
  },
  {
    name: 'Svalbard and Jan Mayen',
    flag: '🇸🇯',
    code: 'SJ',
    dialCode: '+47',
    displayName: '🇸🇯 +47 Svalbard and Jan Mayen (SJ)',
  },
  {
    name: 'Swaziland',
    flag: '🇸🇿',
    code: 'SZ',
    dialCode: '+268',
    displayName: '🇸🇿 +268 Swaziland (SZ)',
  },
  {
    name: 'Sweden',
    flag: '🇸🇪',
    code: 'SE',
    dialCode: '+46',
    displayName: '🇸🇪 +46 Sweden (SE)',
  },
  {
    name: 'Switzerland',
    flag: '🇨🇭',
    code: 'CH',
    dialCode: '+41',
    displayName: '🇨🇭 +41 Switzerland (CH)',
  },
  {
    name: 'Syrian Arab Republic',
    flag: '🇸🇾',
    code: 'SY',
    dialCode: '+963',
    displayName: '🇸🇾 +963 Syrian Arab Republic (SY)',
  },
  {
    name: 'Taiwan',
    flag: '🇹🇼',
    code: 'TW',
    dialCode: '+886',
    displayName: '🇹🇼 +886 Taiwan (TW)',
  },
  {
    name: 'Tajikistan',
    flag: '🇹🇯',
    code: 'TJ',
    dialCode: '+992',
    displayName: '🇹🇯 +992 Tajikistan (TJ)',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    flag: '🇹🇿',
    code: 'TZ',
    dialCode: '+255',
    displayName: '🇹🇿 +255 Tanzania, United Republic of Tanzania (TZ)',
  },
  {
    name: 'Thailand',
    flag: '🇹🇭',
    code: 'TH',
    dialCode: '+66',
    displayName: '🇹🇭 +66 Thailand (TH)',
  },
  {
    name: 'Timor-Leste',
    flag: '🇹🇱',
    code: 'TL',
    dialCode: '+670',
    displayName: '🇹🇱 +670 Timor-Leste (TL)',
  },
  {
    name: 'Togo',
    flag: '🇹🇬',
    code: 'TG',
    dialCode: '+228',
    displayName: '🇹🇬 +228 Togo (TG)',
  },
  {
    name: 'Tokelau',
    flag: '🇹🇰',
    code: 'TK',
    dialCode: '+690',
    displayName: '🇹🇰 +690 Tokelau (TK)',
  },
  {
    name: 'Tonga',
    flag: '🇹🇴',
    code: 'TO',
    dialCode: '+676',
    displayName: '🇹🇴 +676 Tonga (TO)',
  },
  {
    name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    code: 'TT',
    dialCode: '+1868',
    displayName: '🇹🇹 +1868 Trinidad and Tobago (TT)',
  },
  {
    name: 'Tunisia',
    flag: '🇹🇳',
    code: 'TN',
    dialCode: '+216',
    displayName: '🇹🇳 +216 Tunisia (TN)',
  },
  {
    name: 'Turkey',
    flag: '🇹🇷',
    code: 'TR',
    dialCode: '+90',
    displayName: '🇹🇷 +90 Turkey (TR)',
  },
  {
    name: 'Turkmenistan',
    flag: '🇹🇲',
    code: 'TM',
    dialCode: '+993',
    displayName: '🇹🇲 +993 Turkmenistan (TM)',
  },
  {
    name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    code: 'TC',
    dialCode: '+1649',
    displayName: '🇹🇨 +1649 Turks and Caicos Islands (TC)',
  },
  {
    name: 'Tuvalu',
    flag: '🇹🇻',
    code: 'TV',
    dialCode: '+688',
    displayName: '🇹🇻 +688 Tuvalu (TV)',
  },
  {
    name: 'Uganda',
    flag: '🇺🇬',
    code: 'UG',
    dialCode: '+256',
    displayName: '🇺🇬 +256 Uganda (UG)',
  },
  {
    name: 'Ukraine',
    flag: '🇺🇦',
    code: 'UA',
    dialCode: '+380',
    displayName: '🇺🇦 +380 Ukraine (UA)',
  },
  {
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    code: 'AE',
    dialCode: '+971',
    displayName: '🇦🇪 +971 United Arab Emirates (AE)',
  },
  {
    name: 'United Kingdom',
    flag: '🇬🇧',
    code: 'GB',
    dialCode: '+44',
    displayName: '🇬🇧 +44 United Kingdom (GB)',
  },
  {
    name: 'Uruguay',
    flag: '🇺🇾',
    code: 'UY',
    dialCode: '+598',
    displayName: '🇺🇾 +598 Uruguay (UY)',
  },
  {
    name: 'Uzbekistan',
    flag: '🇺🇿',
    code: 'UZ',
    dialCode: '+998',
    displayName: '🇺🇿 +998 Uzbekistan (UZ)',
  },
  {
    name: 'Vanuatu',
    flag: '🇻🇺',
    code: 'VU',
    dialCode: '+678',
    displayName: '🇻🇺 +678 Vanuatu (VU)',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    flag: '🇻🇪',
    code: 'VE',
    dialCode: '+58',
    displayName: '🇻🇪 +58 Venezuela, Bolivarian Republic of Venezuela (VE)',
  },
  {
    name: 'Vietnam',
    flag: '🇻🇳',
    code: 'VN',
    dialCode: '+84',
    displayName: '🇻🇳 +84 Vietnam (VN)',
  },
  {
    name: 'Virgin Islands, British',
    flag: '🇻🇬',
    code: 'VG',
    dialCode: '+1284',
    displayName: '🇻🇬 +1284 Virgin Islands, British (VG)',
  },
  {
    name: 'Virgin Islands, U.S.',
    flag: '🇻🇮',
    code: 'VI',
    dialCode: '+1340',
    displayName: '🇻🇮 +1340 Virgin Islands, U.S. (VI)',
  },
  {
    name: 'Wallis and Futuna',
    flag: '🇼🇫',
    code: 'WF',
    dialCode: '+681',
    displayName: '🇼🇫 +681 Wallis and Futuna (WF)',
  },
  {
    name: 'Yemen',
    flag: '🇾🇪',
    code: 'YE',
    dialCode: '+967',
    displayName: '🇾🇪 +967 Yemen (YE)',
  },
  {
    name: 'Zambia',
    flag: '🇿🇲',
    code: 'ZM',
    dialCode: '+260',
    displayName: '🇿🇲 +260 Zambia (ZM)',
  },
  {
    name: 'Zimbabwe',
    flag: '🇿🇼',
    code: 'ZW',
    dialCode: '+263',
    displayName: '🇿🇼 +263 Zimbabwe (ZW)',
  },
]
export default countriesCode
